// extracted by mini-css-extract-plugin
export default {"header":"Home_header__rABlc","grid":"Home_grid__DmK7x","card":"Home_card__K4FV1","headline":"Home_headline__A0eAO"};